export const SessionStorageKey = {
  UserId: 'SEEL_QUERY_USER_ID',
};
